export default {"src":"/_next/static/media/WELL.eac03bbb.svg","height":18,"width":18};